import {useCallback, useState} from 'react';

export const useBooleanState = () => {
  const [isTurn, setIsTurn] = useState<boolean>(false);
  const turnOn = useCallback(() => setIsTurn(true), []);
  const turnOff = useCallback(() => setIsTurn(false), []);
  const toggle = useCallback(() => setIsTurn(!isTurn), [isTurn]);

  return {
    isTurn,
    turnOn,
    turnOff,
    toggle,
  };
};
